/**
 * router/index.ts
 *
 * Automatic routes for `./src/pages/*.vue`
 */

// Composables
import { createRouter, createWebHashHistory } from 'vue-router';
import { routes } from 'vue-router/auto-routes';

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
});

// Workaround for https://github.com/vitejs/vite/issues/11804
router.onError((err, to) => {
  if (
    err?.message?.includes?.('Failed to fetch dynamically imported module') &&
    !localStorage.getItem('vuetify:dynamic-reload')
  ) {
    localStorage.setItem('vuetify:dynamic-reload', 'true');
    location.assign(to.fullPath);
  }
});

router.isReady().then(() => {
  localStorage.removeItem('vuetify:dynamic-reload');
});

export default router;
